module.exports = __webpack_public_path__ + "static/img/copter_02.ab46709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/copter_02.png
// module id = UJKy
// module chunks = 0